const toast = document.querySelector("[data-toast]");
const root = () => window.Shopify?.routes?.root ?? "/";
let hide = 0;

function say(message) {
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add("is-on");
  clearTimeout(hide);
  hide = window.setTimeout(() => toast.classList.remove("is-on"), 2600);
}

async function refreshCount() {
  const cart = await fetch(`${root()}cart.js`)
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null);
  if (!cart) return;
  const count = cart.item_count ?? 0;
  for (const el of document.querySelectorAll("[data-sack-count]")) {
    el.textContent = String(count);
    el.hidden = count === 0;
  }
}

async function addFromForm(form) {
  const button = form.querySelector('button[type="submit"]');
  if (button) button.disabled = true;
  try {
    const res = await fetch(`${root()}cart/add.js`, {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form),
    });
    if (!res.ok) {
      window.dispatchEvent(new Event("vault:lost"));
      say("Could not CHOMP that.");
      return;
    }
    window.dispatchEvent(new Event("vault:chomp"));
    say("In the sack.");
    await refreshCount();
  } catch {
    say("Could not CHOMP that.");
  } finally {
    if (button) button.disabled = false;
  }
}

/* Anything in the shop may speak through the toast without owning it. */
window.addEventListener("vault:say", (ev) => {
  const line = ev instanceof CustomEvent ? ev.detail : null;
  if (typeof line === "string" && line) say(line);
});

/* THE OFFER HAS TO ANSWER WHEN PRESSED. `week-offer.liquid` sends the shopper
   through Shopify's /discount/CODE route and asks for `offer=on` on the way
   back, because nothing else on the landing page knows the code took: the route
   keeps it in an HttpOnly cookie and the cart has no discounts to list until
   something is in it. The words come off the stamp's data attribute, never from
   here, and the parameter is scrubbed afterwards so a reloaded or shared URL
   cannot keep making the claim on its own. */
function noticeOffer() {
  const url = new URL(location.href);
  if (url.searchParams.get("offer") !== "on") return;
  const line = document.querySelector("[data-offer-say]")?.getAttribute("data-offer-say");
  url.searchParams.delete("offer");
  history.replaceState(null, "", `${url.pathname}${url.search}${url.hash}`);
  /* After the page lands — a toast during paint reads as an error. */
  if (line) setTimeout(() => say(line), 700);
}

noticeOffer();

document.addEventListener("submit", (ev) => {
  const form = ev.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.matches("[data-chomp-form]")) return;
  ev.preventDefault();
  addFromForm(form);
});

function formatMoney(cents, format) {
  const abs = Math.abs(Number(cents) || 0);
  const value = (abs / 100).toFixed(2);
  const formatted = String(format || "${{amount}}")
    .replace("{{amount}}", value)
    .replace("{{amount_no_decimals}}", String(Math.round(abs / 100)))
    .replace("{{amount_with_comma_separator}}", value.replace(".", ","))
    .replace("{{amount_with_apostrophe_separator}}", value.replace(".", "'"));
  return Number(cents) < 0 ? `-${formatted}` : formatted;
}

async function changeLine(key, quantity) {
  const res = await fetch(`${root()}cart/change.js`, {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify({ id: key, quantity }),
  });
  if (!res.ok) {
    say("Could not update the sack.");
    return null;
  }
  return res.json();
}

function paintCart(cart) {
  const form = document.querySelector("[data-cart]");
  const format = form instanceof HTMLElement ? form.dataset.moneyFormat ?? "${{amount}}" : "${{amount}}";
  if (!cart.item_count) {
    window.location.reload();
    return;
  }
  const keys = new Set((cart.items ?? []).map((item) => item.key));
  for (const row of document.querySelectorAll("[data-line-key]")) {
    if (!(row instanceof HTMLElement)) continue;
    const key = row.dataset.lineKey;
    if (key && !keys.has(key) && row.matches(".sack-row")) row.remove();
  }
  for (const item of cart.items ?? []) {
    const row = document.querySelector(`.sack-row[data-line-key="${CSS.escape(item.key)}"]`);
    if (!(row instanceof HTMLElement)) continue;
    const input = row.querySelector("[data-qty-input]");
    if (input instanceof HTMLInputElement) input.value = String(item.quantity);
    const price = row.querySelector("[data-line-price]");
    if (price) price.innerHTML = `<span class="price-mono">${formatMoney(item.final_line_price, format)}</span>`;
  }
  const total = document.querySelector("[data-cart-total]");
  if (total) total.innerHTML = `<span class="price-mono">${formatMoney(cart.total_price, format)}</span>`;
}

document.addEventListener("click", async (ev) => {
  const btn = ev.target instanceof Element ? ev.target.closest("[data-qty-delta]") : null;
  if (!(btn instanceof HTMLButtonElement)) return;
  const wrap = btn.closest("[data-qty-line]");
  const input = wrap?.querySelector("[data-qty-input]");
  if (!(input instanceof HTMLInputElement) || !input.dataset.lineKey) return;
  ev.preventDefault();
  const next = Math.max(0, (Number(input.value) || 0) + Number(btn.dataset.qtyDelta));
  const cart = await changeLine(input.dataset.lineKey, next);
  if (!cart) return;
  paintCart(cart);
  await refreshCount();
});

document.addEventListener("change", async (ev) => {
  const input = ev.target;
  if (!(input instanceof HTMLInputElement) || !input.matches("[data-qty-input]")) return;
  if (!input.dataset.lineKey) return;
  const next = Math.max(0, Number(input.value) || 0);
  const cart = await changeLine(input.dataset.lineKey, next);
  if (!cart) return;
  paintCart(cart);
  await refreshCount();
});
